import type { CommandHistory } from './commandHistory.js';
import type { EditorAction } from './commandExecutor.js';
import type { EditorRuntime } from './editorRuntime.js';

export function configureCommandReplay(
  commandHistory: Pick<CommandHistory, 'configure'>,
  runtime: EditorRuntime,
): void {
  commandHistory.configure<EditorAction>((action) => {
    runtime.executeHistoryAction(action);
  });
}
